import { Controller } from "stimulus";

// A select whose chosen value is the URL its form should submit to.
//
// Replaces an inline onchange handler, which a Content-Security-Policy without
// 'unsafe-inline' blocks (SHP-17632).
//
// Bound through jQuery rather than a Stimulus `change->` action: the global
// initialiser in legacy/index.js applies select2 to this select, and select2
// fires a jQuery change on the hidden original rather than a native event. A
// native listener would never hear it — the inline handler did, because
// jQuery's trigger calls inline handlers.
export default class extends Controller {
  connect() {
    $(this.element).on("change.formActionSelect", () => this.retarget());
  }

  disconnect() {
    $(this.element).off("change.formActionSelect");
  }

  retarget() {
    if (this.element.form) {
      this.element.form.action = this.element.value;
    }
  }
}
